import { render } from "./AppFilterElement.vue?vue&type=template&id=b84a872a&scoped=true"
import script from "./AppFilterElement.vue?vue&type=script&lang=js"
export * from "./AppFilterElement.vue?vue&type=script&lang=js"

import "./AppFilterElement.vue?vue&type=style&index=0&id=b84a872a&lang=scss&scoped=true"

import exportComponent from "/Users/dmytrokulyk/Documents/Development/GreenHub/dsp-f-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b84a872a"]])

export default __exports__